/* SecaMax Vivo — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.sv-reveal:not(.sv-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sv-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var items = document.querySelectorAll('[data-sv-parallax]');
    if (!items.length || reduce) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-sv-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (r.top * -k / 100).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initGallery() {
    document.querySelectorAll('[data-sv-gallery]').forEach(function (g) {
      if (g.dataset.svInit) return; g.dataset.svInit = '1';
      var main = g.querySelector('[data-sv-main]');
      if (!main) return;
      g.querySelectorAll('[data-sv-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = btn.getAttribute('data-src');
            main.srcset = '';
            main.alt = btn.getAttribute('data-alt') || '';
            main.style.opacity = 1;
          }, 150);
          g.querySelectorAll('[data-sv-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    if (!format) return withComma + ' €';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_with_comma_separator') return withComma;
      if (key === 'amount_no_decimals') return parts[0];
      if (key === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withDot;
    });
  }

  function initProduct() {
    document.querySelectorAll('[data-sv-product]').forEach(function (root) {
      if (root.dataset.svInit) return; root.dataset.svInit = '1';
      var dataEl = root.querySelector('[data-sv-variants]');
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var btn = root.querySelector('[data-sv-add]');
      var btnLabel = btn && btn.querySelector('[data-sv-add-label]');
      var buyBtn = root.querySelector('[data-sv-buy]');
      var priceEl = root.querySelector('[data-sv-price]');
      var compareEl = root.querySelector('[data-sv-compare]');
      var saveEl = root.querySelector('[data-sv-save]');
      var stockEl = root.querySelector('[data-sv-stock]');
      var fmt = root.getAttribute('data-money-format');
      var labels = { add: root.getAttribute('data-label-add'), out: root.getAttribute('data-label-out'), instock: root.getAttribute('data-label-instock'), outstock: root.getAttribute('data-label-outstock') };

      var qty = root.querySelector('[data-sv-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(input.value, 10) || 1;
            v = b.getAttribute('data-dir') === 'up' ? v + 1 : Math.max(1, v - 1);
            input.value = v;
          });
        });
      }

      if (!dataEl || !idInput) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      root.querySelectorAll('[data-sv-option]').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var selected = [];
          root.querySelectorAll('[data-sv-option-group]').forEach(function (grp) {
            var c = grp.querySelector('input:checked');
            selected.push(c ? c.value : null);
          });
          var v = variants.find(function (x) {
            return x.options.every(function (o, i) { return o === selected[i]; });
          });
          if (!v) {
            if (btn) btn.disabled = true;
            if (buyBtn) buyBtn.disabled = true;
            if (btnLabel) btnLabel.textContent = labels.out;
            return;
          }
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price, fmt);
          var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
          if (compareEl) { compareEl.textContent = hasCompare ? money(v.compare_at_price, fmt) : ''; compareEl.hidden = !hasCompare; }
          if (saveEl) { saveEl.hidden = !hasCompare; if (hasCompare) saveEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
          if (btn) btn.disabled = !v.available;
          if (buyBtn) buyBtn.disabled = !v.available;
          if (btnLabel) btnLabel.textContent = v.available ? labels.add : labels.out;
          if (stockEl) {
            stockEl.textContent = v.available ? labels.instock : labels.outstock;
            stockEl.classList.toggle('sv-pdp__stock--out', !v.available);
          }
          document.querySelectorAll('[data-sv-sticky-price]').forEach(function (p) { p.textContent = money(v.price, fmt); });
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-sv-sticky]');
    var anchor = document.querySelector('[data-sv-add]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    });
    io.observe(anchor);
    var go = bar.querySelector('[data-sv-sticky-go]');
    var buy = document.querySelector('[data-sv-buy]');
    var hasOptions = document.querySelector('[data-sv-option]');
    if (go) go.addEventListener('click', function () {
      if (buy && !buy.disabled && !hasOptions) { buy.click(); return; }
      anchor.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }

  function initAll() {
    initReveal(); initParallax(); initGallery(); initProduct(); initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // Editor de Shopify: re-inicializa al añadir/editar secciones
  document.addEventListener('shopify:section:load', initAll);
})();
